import React, { useState } from "react";
import DomainManagementSection from "../domainManagement/DomainManagementSection";
import { ChevronDown } from 'lucide-react';



export default function DomainSection() {

  const [collapsed, setCollapsed] = useState(true);

  return (
    <>
      <button
        className="oct_settings-section-header"
        onClick={() => setCollapsed(!collapsed)}
      >
        <h3>Domain Management</h3>
        <ChevronDown className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}/>
      </button>

      <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
        <DomainManagementSection />
        {/* <div className="col">
                <MLThresholdSection/>
        </div> */}
      </div>
      {/* <div className="row">
              <MlLoginKeywordSection/>
            </div> */}
    </>
  );
}
